import { render, staticRenderFns } from "./LanguageStep.vue?vue&type=template&id=3ed8e0f4&"
import script from "./LanguageStep.vue?vue&type=script&lang=js&"
export * from "./LanguageStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed8e0f4')) {
      api.createRecord('3ed8e0f4', component.options)
    } else {
      api.reload('3ed8e0f4', component.options)
    }
    module.hot.accept("./LanguageStep.vue?vue&type=template&id=3ed8e0f4&", function () {
      api.rerender('3ed8e0f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Onboarding/Components/LanguageStep.vue"
export default component.exports